export default {
  title: {
    id: 'asp_agent_action_bar_refund_step_title',
    defaultMessage: 'Refund item',
  },
  inputAmount: {
    id: 'asp_agent_action_bar_refund_step_input_amount',
    defaultMessage: 'Refund amount (shipping costs included)',
  },
  reasonSelect: {
    id: 'asp_agent_action_bar_refund_step_reason_for_partial_refund_label',
    defaultMessage: 'What’s the reason for this partial refund?',
  },
  messageInput: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_explanation_input_label',
    defaultMessage: 'Tell us what’s going on in a few words',
  },
  refundButton: {
    id: 'asp_agent_action_bar_refund_step_refund_cta',
    defaultMessage: 'Refund',
  },
  isRequired: {
    id: 'asp_agent_action_bar_refund_step_field_required',
    defaultMessage: 'This field is required.',
  },
  accessoryProblemReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_accessory_problem_label',
    defaultMessage: 'Accessory problem',
  },
  returnLabelFeesReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_return_label_fees_label',
    defaultMessage: 'Return label fees',
  },
  thirdPartyRepairReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_third_party_repair_label',
    defaultMessage: 'Third party repair',
  },
  appearanceIssueReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_appearance_issue_label',
    defaultMessage: 'Appearance issue',
  },
  performanceIssueReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_performance_issue_label',
    defaultMessage: 'Performance issue',
  },
  otherReason: {
    id: 'asp_agent_action_bar_refund_step_partial_refund_reason_other_label',
    defaultMessage: 'Other',
  },
  characterLimitErrorMessage: {
    id: 'asp_agent_action_bar_refund_step_character_limit_error',
    defaultMessage: 'You’ve reached the character limit',
  },
  errorToastTitle: {
    id: 'asp_agent_action_bar_refund_step_error_toast_title',
    defaultMessage: "Hmm, that didn't work.",
  },
  errorToastLabel: {
    id: 'asp_agent_action_bar_refund_step_error_toast_label',
    defaultMessage: 'Please try again.',
  },
}
